

import React, { useEffect, useRef, useState } from "react";
import "./CoursePageAllStyles.css"
import { coursePageObject } from "./ExportCoursePageObject";
import CoursePageLeftCard from "./CoursePageLeftCard";
import CoursePageTopSection from "./CoursePageTopSection";
import WhatWillYouLearnCoursePage from "./WhatWillYouLearnCoursePage";
import CoursePageCardSubCourseHolder from "./CoursePageCardSubCourseHolder";
import CoursePageSkills from "./CoursePageSkills";
import CourseContentCardHolder from "./CourseContentCardHolder";
import CoursePageHighlightsPrerequisiteAudience from "./CoursePageHighlightsPrerequisiteAudience";
import CoursePageGiftCard from "./CoursePageGiftCard";
import CourePageFAQCard from "./CourePageFAQCard";

  
const CoursePageCard= ({})=>{ 
      // const [coursePageObject,setCourseObject] =useState(coursePageObject)
   const [deviceWidth,setDeviceWidth] = useState(false);
    const bottomDivRef = useRef(null);
    
    const bottomDivBoxRef = useRef(null);
    const bodyWidthForMobile =useRef(null)
    
    const [isVisible, setIsVisible] = useState(false);
  
    const [divHeight, setDivHeight] = useState(0);
 
useEffect(() => {
      // setVideoInPlayer(courseData?.CourseVideoLinks!=[]?courseData?.CourseVideoLinks[0]:"")
      if (bodyWidthForMobile.current) {
        let offsetWidth = window.body?.offsetWidth;
          setDeviceWidth(offsetWidth)
      }
      setDivHeight(bottomDivBoxRef?.current?.offsetHeight);
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true); // Set state when the div appears
          } else {
            setIsVisible(false); // Reset state if it goes out of view
          }
        },
        {
          root: null, // Observe within the viewport
          threshold: 1.0, // Trigger only when fully visible (at the bottom of the viewport)
        }
      );
  
      if (bottomDivRef.current) {
        observer.observe(bottomDivRef.current);
      }
  
      return () => {
        if (bottomDivRef.current) {
          observer.unobserve(bottomDivRef.current);
        }
      };
    }, [deviceWidth])



     return(<>
     
  <div style={{background:`${coursePageObject?.outerCard?.layoutBG?.color}`,
border:` ${coursePageObject?.outerCard?.border?.borderWidth?.value+coursePageObject?.outerCard?.border?.borderWidth?.resolution} ${coursePageObject?.outerCard?.border?.borderType}  ${coursePageObject?.outerCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.outerCard?.borderRadius?.topLeft?.value}${coursePageObject?.outerCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.outerCard?.borderRadius?.topRight?.value}${coursePageObject?.outerCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.outerCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.outerCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.outerCard?.borderRadius?.bottomRight?.value}${coursePageObject?.outerCard?.borderRadius?.bottomRight?.resolution}`,
            }}  >
 

 <div ref={bodyWidthForMobile} className="" style={{ }} >
 {/* <div className="content-topk"></div>  */}
  
 {true?
    <div className="courseCourseCardlOuterGrid" style={{ minHeight:"85vh",overflowX:"hidden", position:"relative",

    }} >
      <div>
        <div  className={`${!isVisible?"fixed-div-courseCard1":"normal-div-last-courseCard1"}  `}
        style={{ textAlign:"left" ,padding:"0px",background:`${coursePageObject?.sidebarCard?.bgColor?.color}`,
border:` ${coursePageObject?.sidebarCard?.border?.borderWidth?.value+coursePageObject?.sidebarCard?.border?.borderWidth?.resolution} ${coursePageObject?.sidebarCard?.border?.borderType}  ${coursePageObject?.sidebarCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.sidebarCard?.borderRadius?.topLeft?.value}${coursePageObject?.sidebarCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.sidebarCard?.borderRadius?.topRight?.value}${coursePageObject?.sidebarCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.sidebarCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.sidebarCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.sidebarCard?.borderRadius?.bottomRight?.value}${coursePageObject?.sidebarCard?.borderRadius?.bottomRight?.resolution}`,
         }} 
      >
       <CoursePageLeftCard  coursePageObject={coursePageObject} />
       <div  ref={bottomDivBoxRef}></div>
</div ></div>
<div className=" " style={{padding:"10px",background:`${coursePageObject?.mainCard?.layoutBG?.color}`,
border:` ${coursePageObject?.mainCard?.border?.borderWidth?.value+coursePageObject?.mainCard?.border?.borderWidth?.resolution} ${coursePageObject?.mainCard?.border?.borderType}  ${coursePageObject?.mainCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.mainCard?.borderRadius?.topLeft?.value}${coursePageObject?.mainCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.mainCard?.borderRadius?.topRight?.value}${coursePageObject?.mainCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.mainCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.mainCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.mainCard?.borderRadius?.bottomRight?.value}${coursePageObject?.mainCard?.borderRadius?.bottomRight?.resolution}`,
 }} >
 <CoursePageTopSection coursePageObject={coursePageObject} />
 
<WhatWillYouLearnCoursePage coursePageObject={coursePageObject} />

<CoursePageCardSubCourseHolder coursePageObject={coursePageObject} />
 
<CoursePageSkills coursePageObject={coursePageObject} />
 
<CourseContentCardHolder  coursePageObject={coursePageObject} />

<CoursePageHighlightsPrerequisiteAudience  coursePageObject={coursePageObject} />
     
<CoursePageGiftCard  coursePageObject={coursePageObject} />
     
<CourePageFAQCard  coursePageObject={coursePageObject} />
     

</div>
<div>
</div>
</div>:""}
<div ref={bottomDivRef} ></div>
<div style={{ height: "500px" ,}} ></div>  
</div>
  </div> 
<style>{`
.coursePageHeaderFont{
  font-family:${coursePageObject?.titleFonts?.headerFont?.family?.fontFamily};;
}

.coursePageTitleFont{
  font-family:${coursePageObject?.titleFonts?.titleFont?.family?.fontFamily};;
}
.coursePageSubTitleFont{
  font-family:${coursePageObject?.titleFonts?.subtitleFont?.family?.fontFamily};;
}
  .coursePageTagsFont{
  font-family:${coursePageObject?.titleFonts?.tagsFont?.family?.fontFamily};;
}.coursePageButtonFont{
  font-family:${coursePageObject?.titleFonts?.buttonFont?.family?.fontFamily};;
}  .shareWishlistTextCoursePage{display:none }

   .themeCoursePage{
       padding:15px !important;padding-top:5px !important
    }
.courseCourseCardlOuterGrid{
  display:grid;padding-top:60px;
  grid-template-columns:  500px auto 5%;
}
        .normal-div-last-courseCard1{
        width: 380px; 
        position: absolute;;
      bottom:0px ;
        visibility:visible;left:100px !important;
        overflow: hidden;overflow-y: auto !important;
        color:#9690da;;background: #fff;
        font-size: 20px;
           font-weight: 900;text-align: center;
           margin:0px;
         z-index: 999;
           border-radius: 45px;;  box-shadow: 0 7px 20px 0 rgba(48, 25, 131, 0.13);
      }

        .fixed-div-courseCard1 {  width: 380px;
          position: fixed;background: #fff;
          top: 60px !important;
          visibility:visible;left:100px ;
          overflow: hidden;
          color:#9690da;
            font-size: 20px;
             font-weight: 900;text-align: center;
             margin:0px;
             z-index: 999;
             border-radius: 45px;;  box-shadow: 0 7px 20px 0 rgba(48, 25, 131, 0.13);
             transition: width 0.9s ease;
        }

          .product-tag-themeCoursePage {
          
    background: ${coursePageObject?.sidebarStatusTag?.bgColor?.color};;
    opacity: 1;text-align: left;
    display: inline-block;
    position: relative;
    top: 35px;
   border:  ${coursePageObject?.sidebarStatusTag?.border?.borderWidth?.value+coursePageObject?.sidebarStatusTag?.border?.borderWidth?.resolution} ${coursePageObject?.sidebarStatusTag?.border?.borderType}  ${coursePageObject?.sidebarStatusTag?.border?.borderColor?.color};
  border-top-left-radius:${coursePageObject?.border?.borderRadius?.topLeft?.value}${coursePageObject?.border?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${coursePageObject?.border?.borderRadius?.topRight?.value}${coursePageObject?.border?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${coursePageObject?.border?.borderRadius?.bottomLeft?.value}${coursePageObject?.border?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${coursePageObject?.border?.borderRadius?.bottomRight?.value}${coursePageObject?.border?.borderRadius?.bottomRight?.resolution};
        
    
  
   left: 0px;
    text-transform: uppercase;
    color: ${coursePageObject?.sidebarStatusTag?.textColor?.color};
    font-size: 13px;
    font-weight: 700;
    z-index: 1;
    padding: 2px 10px;
    z-index: 999;
    line-height: 20px
}
     
.catUndrlineCoursePage{text-decoration: underline; font-size: 18px;font-weight: 600;;}
.coursePageWhatsIncluded{display:flex;flex-direction:row}

.product-tag-themeCoursePage:after {
    content: "";
    position: absolute;
    border-color:  ${coursePageObject?.sidebarStatusTag?.border?.borderColor?.color} transparent  ${coursePageObject?.sidebarStatusTag?.border?.borderColor?.color}  ${coursePageObject?.sidebarStatusTag?.border?.borderColor?.color};
    border-style: solid;
    border-width: 10px;
    left: 100%;
    width: 0;
    height: 0;
    top: 2px;
}



  .scroller-wrapperCoursePage {
    display: flex;
    align-items: center;
    position: relative;
    position: absolute;left:0px;right:0px;
    
    margin: auto;
  }
  
  .scrollerCoursePage {
    display: flex;
    gap: 10px;
    overflow: hidden;
    scroll-behavior: smooth;
    white-space: nowrap;
    width: 100%;
    padding: 10px 0;
  }
  
  
  
  .scroll-btnCoursePage {
    background-color: #2c3e50;
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    font-size: 18px;
    border-radius: 5px;
  }
  
  .scroll-btnCoursePage:hover {
    background-color: #1a252f;
  }
  
  .left {
    margin-right: 5px;
  }
  
  .right {
    margin-left: 5px;
  }

  .courseWhatWillearnTextCoursePage{
  
  display:grid; margin-top: 30px;
  grid-template-columns:  50% 50%;
}
   .courseContentTitleFontCoursePage{ margin-top:30px;
    font-size: 25px;font-weight: 600;padding: 19px;
  }
    .courseContentTitleFontTwoCoursePage{margin-top:35px;
    font-size: 35px;font-weight: 600;padding: 19px;}
 .gridForCoursePageFiftyFifty{
        display:grid;gap:10px;
    grid-template-columns:50% 50% ;
    }
    
.grid2080CoursePage{ display:grid;
  grid-template-columns: 15% 85%;}

  
.FAQShadowCoursePage{border-radius: 15px;padding:0px ;margin-top: 20px !important;
    box-shadow: 0 7px 20px 0 rgba(48, 25, 131, 0.053);overflow: hidden;}

.FAOuterTitleCoursePage{display:grid; margin-top: 0px;padding: 10px;
  grid-template-columns:  10% auto;font-size: 34px;}

  .FAQGridTitleCoursePage{
  display:grid; margin-top: 0px;padding: 10px;
  grid-template-columns:  10% auto;
}
  .FAQActiveCoursePage{
  display:grid; margin-top: 0px;margin-bottom: 10px;background: rgba(255,114,94,0.1) ;;
  grid-template-columns:   auto  8%;padding: 5px; padding-top: 15px; border-radius: 0px;
}

.FAQInActiveCoursePage{
  display:grid; margin-top: 0px;margin-bottom: 10px;
  grid-template-columns:   auto  8%;padding: 5px; padding-top: 15px; border-radius: 0px;
}

.FAQQuestionStyleCoursePage{
  font-size:16px;color:#555;font-weight:700;
}
  .FAQItemInnerCoursePage{
  
  display:grid; margin-top: 5px;
  grid-template-columns:  5% auto ;padding: 5px;
}
 /* md */
   @media (min-width: 992px) and (max-width: 1199px) {
   .courseCourseCardlOuterGrid{
 
  grid-template-columns:  300px 65%  !important;
}
  .normal-div-last-courseCard1{
       width: 280px;left:10px !important;
}
  .fixed-div-courseCard1{
    width: 280px;left:20px !important; }
  
 
}


 /* sm */
      @media (min-width: 768px) and (max-width: 991px) {
      .gridForCoursePageFiftyFifty{  margin-left: 5%; grid-template-columns:  90%;}
    .courseCourseCardlOuterGrid{
 
        grid-template-columns:  auto  !important;
      }
        .normal-div-last-courseCard1,.fixed-div-courseCard1 {
    position: relative !important; top: 0vh !important;
    right:0px !important;width: 100% !important;
     left:0px !important;
  }
  
}

/* xs */
  @media (max-width: 767px) {
 .gridForCoursePageFiftyFifty {
        margin-left: 0%;
        grid-template-columns:  100%  ;}
  .coursePageWhatsIncluded{display:flex;flex-direction:column !important}

   .shareWishlistTextCoursePage,.BottomCardXsCourse{display:block !important;z-index:99;}
   .courseCourseCardlOuterGrid{
   
    grid-template-columns: 100% !important;
  }   
    
.normal-div-last-courseCard1{
       
  position: relative !important;
  right:0px !important; left:0px !important;
  width: 100% !important
}
  .fixed-div-courseCard1 {
    position: relative !important; top: 0vh !important;
    right:0px !important;width: 100% !important;
    height:100%;; left:0px !important;
  } .courseWhatWillearnTextCoursePage{
    display: grid !important;
    grid-template-columns:100% !important;; /* Two columns of equal width */
    grid-auto-rows: auto; /* Automatic row heights */
    
  }
    .courseContentTitleFontTwoCoursePage{margin-top:20px;
    font-size: 25px;font-weight: 600;padding: 19px;}
.FAOuterTitleCoursePage{
  font-size: 26px;
  grid-template-columns:  20% auto;
}
  .FAQGridTitleCoursePage{
  
  grid-template-columns:  20% auto;
}
  .FAQInActiveCoursePage,.FAQActiveCoursePage{
 
  grid-template-columns:   auto  12%;
}
    
}

`}</style>
    </>
                            
   )  
   }
   export default CoursePageCard;